export const languageMiddleware = async req => {
  req.headers.set('Accept-Language', navigator.language)

  return req
}
